import { OrbitApi } from 'api'

class AuthFaberApi {
  static validateToken({ faberToken: faberToken }) {
    return OrbitApi.httpPost(
      '/faber/auth/validate',
      {},
      { token: faberToken }
    )
  }
}

export default AuthFaberApi
